// extracted by mini-css-extract-plugin
module.exports = {"listSidebar":"user-sidebar_listSidebar__3Mu9x","listItem":"user-sidebar_listItem___dnm3","listIcon":"user-sidebar_listIcon__DoJo6","activeItem":"user-sidebar_activeItem__2PTDd"};